export default {
    title_list: 'Types of artifcts',
    title_page: 'Artifct type',
    title_create_page: 'Create type',
    title_edit_page: 'Change type',

    filter: {
        labels: {
            title: 'Title',
            parent_id: 'Parent type',
            position: 'Position',
            is_parent: 'Is parent'
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Title',
            parent_id: 'Parent type',
            position: 'Position'
        }
    },

    buttons: {

    },

    form: {
        title: 'Title',
        parent_id: 'Parent type',
        position: 'Position'
    },
}
